export enum LoginAction {
    Login = "login",
    LoginCallback = "login-callback",
    LoginFailed = "login-failed",
    Profile = "profile",
    Register = "register"
}